import React from 'react';
import { Link } from 'react-router-dom';
import ContactForm from '../components/ContactForm';

const Practical: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 mt-10">
      <h1 className="text-4xl font-bold mb-8">Praktische Informatie</h1>
      
      <div className="space-y-12">
        {/* Lesrooster Sectie */}
        <section>
          <h2 className="text-2xl font-semibold mb-4">Lesrooster</h2>
          <div className="bg-white rounded-lg shadow p-6 mb-6">
                        <table className="text-left">
              <tbody>
                <tr className="border-b border-gray-200">
                  <td className="py-2 pr-4"><span className="font-semibold">Dinsdag</span> (even weken)</td>
                  <td className="py-2 pr-4">Bukiwaza (wapentraining)</td>
                  <td className="py-2 text-right">20:00 - 21:30</td>
                </tr>
                <tr className="border-b border-gray-200">
                  <td className="py-2 pr-4"><span className="font-semibold">Dinsdag</span> (oneven weken)</td>
                  <td className="py-2 pr-4">Algemene training</td>
                  <td className="py-2 text-right">20:00 - 21:30</td>
                </tr>
                <tr>
                  <td className="py-2 pr-4 font-semibold">Zondag</td>
                  <td className="py-2 pr-4">Algemene training</td>
                  <td className="py-2 text-right">10:30 - 12:00</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        {/* Tarieven Sectie */}
        <section>
          <h2 className="text-2xl font-semibold mb-4">Tarieven</h2>
          <div className="bg-white rounded-lg shadow p-6">
            <div className="space-y-3">
              <p><strong>Maandelijks lidmaatschap:</strong> €35,-</p>
              <p><strong>Strippenkaart:</strong> €30 voor 4 lessen, drie maanden geldig</p>
              <p><strong>Proefles:</strong> Gratis</p>
              
              <p className="mt-4">
                Wij zijn aangesloten bij Gelrepas en Sportkaart Arnhem. Gelrepas biedt 50% korting op lidmaatschap met alle rechten van leden zoals examens kunnen doen en toegang tot ALV en verenigingsactiviteiten. Sportkaart biedt toegang tot de lessen maar is bedoeld voor de gelegenheidstrainer die op incidentele basis traint. Wil je echt verder op het aikidopad en deelnemen aan de stages en examens? Dan ben je van harte welkom om lid te worden.
              </p>
            </div>
            <div className="mt-4 pt-4 border-t border-gray-200">
              <p><strong>Bankgegevens:</strong></p>
              <p>IBAN: NL67 TRIO 0321038762</p>
            </div>
          </div>
        </section>

        {/* Exameneisen Sectie */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="flex items-center justify-center order-2 md:order-1">
            <img 
              src="/images/Wapenles.jpg" 
              alt="Wapenles" 
              className="rounded-lg shadow-lg w-full h-auto max-h-80 object-cover"
            />
          </div>
          <section className="order-1 md:order-2">
          <h2 className="text-2xl font-semibold mb-4">Exameneisen</h2>
          <div className="bg-white rounded-lg shadow p-6">
            <p className="mb-4">
              Voor het behalen van een kyu-graad zijn er specifieke exameneisen opgesteld. 
              Deze eisen helpen je om gericht te trainen en je voor te bereiden op je examen.
            </p>
            <Link 
              to="/kyu-requirements" 
              className="inline-block bg-[#411217] text-white px-4 py-2 rounded hover:bg-[#2a0b0e] transition-colors"
            >
              Bekijk Exameneisen
            </Link>
          </div>
          </section>
        </div>

        {/* Huisregels Sectie */}
        <section>
          <h2 className="text-2xl font-semibold mb-4">Huisregels</h2>
          <div className="bg-white rounded-lg shadow p-6">
            <ul className="list-disc list-inside space-y-2">
              <li>Kom op tijd voor de les</li>
              <li>Zorg voor persoonlijke hygiëne</li>
              <li>Draag kleding waar je gemakkelijk in kunt bewegen</li>
              <li>Respecteer je trainingspartner</li>
              <li>Volg de aanwijzingen van de leraar</li>
            </ul>
          </div>
          <div className="mt-6">
            <img 
              src="/images/Gelijkwaardigheid.jpg" 
              alt="Gelijkwaardigheid" 
              className="rounded-lg shadow-lg w-full h-auto max-w-2xl mx-auto"
            />
          </div>
        </section>

        {/* FAQ Sectie */}
        <section>
          <h2 className="text-2xl font-semibold mb-4">Veel gestelde vragen</h2>
          <div className="space-y-4">
            <div className="bg-white rounded-lg shadow p-6">
              <h3 className="font-semibold mb-2">Wat moet ik meenemen naar de eerste les?</h3>
              <p className="text-gray-600">Gemakkelijk zittende sportkleding, slippers en een flesje water. Een aikidopak is pas nodig als je echt wilt beginnen.</p>
            </div>
            <div className="bg-white rounded-lg shadow p-6">
              <h3 className="font-semibold mb-2">Hoe lang duurt een training?</h3>
              <p className="text-gray-600">Een reguliere training duurt 90 minuten, inclusief warming-up en cooling-down.</p>
            </div>
            <div className="bg-white rounded-lg shadow p-6">
              <h3 className="font-semibold mb-2">Vanaf welke leeftijd kan ik beginnen?</h3>
              <p className="text-gray-600">Onze trainingen zijn geschikt voor mensen vanaf 16 jaar. Er is geen maximum leeftijd.</p>
            </div>
          </div>
        </section>

        {/* Contact Formulier Sectie */}
        <section id="contact">
          <h2 className="text-2xl font-semibold mb-4">Neem contact op</h2>
          <p className="mb-4">Heb je een vraag/ wil je meer weten? Stuur dan een bericht via onderstaand formulier.</p>
          <ContactForm />
        </section>
      </div>
    </div>
  );
};

export default Practical;
